import type { Hotel } from '@/config/objects/hotels';
import { createEntityApi } from '@startupquickstart/frontend';

const hotelsApi = createEntityApi<Hotel>({ resource: 'hotels', queryKey: 'Hotel' });

export const useHotel = hotelsApi.useOne;
export const useHotels = hotelsApi.useMany;
export const useCreateHotel = hotelsApi.useCreate;
export const useUpdateHotel = hotelsApi.useUpdate;
export const useDeleteHotel = hotelsApi.useDelete;
